import Button from 'Component/Button';
import Icons from 'Component/Icons';
import { WishlistItem as SourceWishlistItem } from 'SourceComponent/WishlistItem/WishlistItem.component';

import './WishlistItem.style';
import './WishlistItem.override.style';

/** @namespace Advox/Component/WishlistItem/Component */
export class WishlistItem extends SourceWishlistItem {
    renderRemove() {
        const { removeItem } = this.props;

        return (
            <button block="WishlistItem" elem="Remove" onClick={removeItem} aria-label={__('Remove')}>
                <Icons name="trash" fill="#797979" width="16px" />
            </button>
        );
    }

    renderAddToCartButton() {
        const { addToCart, isEditingActive, isMobile, inStock } = this.props;

        const mods = isMobile ? { isEditingActive } : {};

        return (
            <Button
                mix={{ block: 'WishlistItem', elem: 'AddToCart', mods }}
                onClick={addToCart}
                disabled={!inStock}
                size="medium"
            >
                {__('Add to cart')}
            </Button>
        );
    }

    renderContent = (renderMethods) => {
        const {
            content: { productPrice },
            pictureBlock: { picture: renderPicture },
            renderCardLinkWrapper,
        } = renderMethods;

        return (
            <>
                <div block="WishlistItem" elem="FigureWrapper">
                    {renderCardLinkWrapper(
                        <>
                            <figure mix={{ block: 'ProductCard', elem: 'Figure' }}>
                                {renderPicture({ block: 'WishlistItem', elem: 'Picture' })}
                            </figure>
                            <div block="WishlistItem" elem="Content">
                                {this.renderName()}
                                {this.renderOptions()}
                                {this.renderPrice(productPrice)}
                            </div>
                        </>
                    )}
                    {this.renderRemove()}
                </div>

                <div block="WishlistItem" elem="ActionWrapper">
                    {this.renderQuantityFieldInput()}
                    {this.renderAddToCartButton()}
                </div>
            </>
        );
    };
}

export default WishlistItem;
